
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qr-code-generator",
      function () {
        return require("private-next-pages/qr-code-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qr-code-generator"])
      });
    }
  